export enum ClassificationType {
  Situation = 0,
  Response = 1,
}

export interface Category {
  id: string;
  categoryName: string;
  classificationType: ClassificationType;
  createdAt: string;
}

export interface CategoriesResponse {
  categories: Category[];
  params: { pageSize: number; pageIndex: number };
  total: number;
}

export interface ResponseCategory {
  id: string;
  name: string;
  classificationType: ClassificationType;
}

export interface ResponseCategoriesResponse {
  responseCategories: ResponseCategory[];
  total: number;
}

export interface SituationCategory {
  id: string;
  name: string;
  classificationType: ClassificationType;
}

export interface SituationCategoriesResponse {
  situationCategories: SituationCategory[];
  total: number;
}
